import { render } from "./MarkProducts.vue?vue&type=template&id=589c5ce7&scoped=true"
import script from "./MarkProducts.vue?vue&type=script&lang=js"
export * from "./MarkProducts.vue?vue&type=script&lang=js"

import "./MarkProducts.vue?vue&type=style&index=0&id=589c5ce7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-589c5ce7"]])

export default __exports__